<template>
	<el-container class="studentcp" v-loading="loading" element-loading-text="同步中请稍后">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-row :gutter="0">
				<el-col :span="4">
					<el-card class="tree-box">
						<el-scrollbar style="height:100%">
							<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" :default-expand-all="true"></el-tree>
						</el-scrollbar>
					</el-card>
				</el-col>
				<el-col :span="20">
					<div class="box">
						<el-card class="screen-box">
							<el-form ref="form" :model="searchForm" :inline="true" size="small">
								<el-form-item label="学生姓名:">
									<el-input placeholder="请输入学生姓名" v-model="searchForm.nick"></el-input>
								</el-form-item>
								<el-form-item label="学号:">
									<el-input placeholder="请输入学号" v-model="searchForm.studentNo"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
									<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
									<el-button @click="importInfo()" icon="el-icon-download" type="primary" size="small">导入学生信息</el-button>
									<el-popconfirm title="您确定要同步吗？" @confirm="synchronous()">
										<el-button slot="reference" style="margin: 0 10px;" icon="el-icon-refresh" type="primary" size="small">同步数据</el-button>
									</el-popconfirm>
									<el-button @click="sendMsg()" icon="el-icon-position" type="primary" size="small">发送通知</el-button>
								</el-form-item>
							</el-form>
						</el-card>
						<el-card class="table-box">
							<el-table :data="tableList" id="table" border>
								<el-table-column type="index" width="50"></el-table-column>
								<template v-for="(item, index) in tableLabel">
									<el-table-column :key="index" :prop="item.prop" :label="item.label"
										:formatter="item.formatter"></el-table-column>
								</template>
								<el-table-column label="操作" width="210">
									<template slot-scope="scope">
										<el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
										<el-button type="text" size="mini" @click="parentsList(scope.row)">家长列表</el-button>
										<el-popconfirm title="您确定要同步吗？" @confirm="singleSynchronous(scope.row)">
											<el-button type="text" size="mini" slot="reference" style="margin: 5px 10px 0 10px;">同步</el-button>
										</el-popconfirm>
										<el-button type="text" size="mini" @click="sendMsg(scope.row)">发送通知</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit"
								layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
						</el-card>
					</div>
				</el-col>
			</el-row>
		</el-main>
		
		<!-- 弹出层：编辑学生信息 -->
		<el-dialog title="编辑学生信息" :visible.sync="dialogFormVisible">
			<el-form :model="form" label-width="70px" size="small">
				<el-form-item label="学生姓名">
					<el-input placeholder="请输入学生姓名" v-model="form.studentName"></el-input>
				</el-form-item>
				<el-form-item label="学号">
					<el-input placeholder="请输入学号" v-model="form.studentNo"></el-input>
				</el-form-item>
				<el-form-item label="身份证">
					<el-input placeholder="请输入身份证" v-model="form.idCard"></el-input>
				</el-form-item>
				<el-form-item label="学生类型">
					<el-select placeholder="请选择学生类型" v-model="form.type">
						<el-option label="走读生" value="0"></el-option>
						<el-option label="住校生" value="1"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="formSubmit()" size="small">确 定</el-button>
			</div>
		</el-dialog>
		
		<!-- 弹出层：家长列表 -->
		<el-dialog title="家长列表" :visible.sync="dialogParentListVisible">
			<el-table :data="parentList" id="parentTable" border>
				<el-table-column type="index" width="50"></el-table-column>
				<template v-for="(item, index) in parentLabel">
					<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
					</el-table-column>
				</template>
			</el-table>
		</el-dialog>
		
		<!-- 弹出层：导入学生信息 -->
		<el-dialog title="导入学生信息" :visible.sync="dialogImportVisible">
			<el-upload drag ref="upload" action="http://120.77.10.20:8800/cp/student/upload_student_info" :show-file-list="false" accept=".xls,.xlsx" :auto-upload="false" :file-list="fileList" :data="uploadData" :headers="uploadHead" :on-change="importExcel" :on-success="importSuccess">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			</el-upload>
			<el-table :data="importList" id="importTable" border>
				<el-table-column type="index" width="50"></el-table-column>
				<template v-for="(item, index) in importLabel">
					<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
					</el-table-column>
				</template>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="warning" size="small" download="学生录入模板" icon="download" href="/excel/学生录入模板.xlsx">下载模板</el-button>
				<el-button @click="dialogImportVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="importConfirm()" size="small">导入</el-button>
			</div>
		</el-dialog>
		
		<!-- 弹出层：发送通知 -->
		<el-dialog title="发送通知" :visible.sync="dialogSendMsgVisible" class="msgDialog">
			<el-form label-width="70px" size="small">
				<el-form-item label="发布对象">
					<el-radio-group v-model="msgForm.type" @change="radioChange">
						<el-radio label="班级" value="2"></el-radio>
						<el-radio label="学生" value="1"></el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<el-form :inline="true" label-width="70px" size="small">
				<el-form-item :label="text">
					<el-card class="sel-box">
						<div class="classAndGrade" v-if="msgForm.type == '班级'" >
							<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
							<el-tree ref="tree" :data="data" :props="defaultProps" @node-click="dialogHandleNodeClick"
							:default-expand-all="true" show-checkbox @check-change="handleCheckChange" :filter-node-method="filterNode"></el-tree>
						</div>
						<div class="student" v-if="msgForm.type == '学生'">
							<el-tag :key="tag.id" v-for="(tag,index) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag,index)">
								{{tag.label}}
							</el-tag>
							<el-input placeholder="输入学生姓名进行搜索" v-model="msgInput" @input="handlerChange" style="width: 100% !important;"></el-input>
							<el-tree :data="msgTreeData" :props="msgTreeDefaultProps" :default-expand-all="true" show-checkbox @check-change="msghHandleCheckChange"></el-tree>
						</div>
					</el-card>
				</el-form-item>
				<el-form-item label="通知内容">
					<el-input type="textarea" v-model="msgForm.content"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSendMsgVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="send()" size="small">发 送</el-button>
			</div>
		</el-dialog>

		<!-- 弹出层：同步数据 -->
		<el-dialog title="以下学生拥有多个班级，请到企微处理。" :visible.sync="dialogSynchronization" class="synchronizationDialog">
			<div v-html="synchronizationHtml"></div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSynchronization = false" size="small">关 闭</el-button>
				<el-button type="primary" @click="copy()" size="small">复 制</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import {
		levelTreeApi,
		cpStudentPageApi,
		parentListApi,
		sendParentMessageApi,
		cpStudentSyncApi,
		syncOneApi,
		updateStudentInfoApi,
		uploadStudentInfoApi,
		importStudentInfoApi,
		levelListApi,
		cpLikeNameApi
	} from "@/axios/api";
	import XLSX from "xlsx";
	export default {
		name: "Studentcp",
		data() {
			return {
				loading:false,
				totalCount: 0,
				pageSizes: [10],
				searchForm: {
					// externalId:'',//外部学生ID
					levelIds: [], //班级id
					nick: null, //	学生名称
					studentNo: null, //学生编号
					isSearchCount: true,
					limit: 10,
					page: 1
				},
				tableList: [],
				tableLabel: [{
					label: "学生姓名",
					prop: "studentName"
				}, {
					label: "班级",
					prop: "levelName"
				}, {
					label: "学号",
					prop: "studentNo"
				}, {
					label: "性别",
					prop: "gender",
					formatter: (row) => {
						return row.gender ? '男' : '女';
					}
				}, {
					label: "学生类型",
					prop: "type",
					formatter: (row) => {
						return row.type == 1 ? '住校生' : '走读生';
					}
				}, {
					label: "身份证",
					prop: "idCard"
				}, {
					label: "更新时间",
					prop: "updateTime"
				}],

				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},

				//编辑学生信息
				dialogFormVisible: false,
				form: {
					studentName: '',
					studentNo: '',
					idCard: '',
					type: '',
					id: ''
				},

				//家长列表
				dialogParentListVisible: false,
				parentList: [],
				parentLabel: [{
					label: "孩子关系",
					prop: "relation"
				}, {
					label: "联系方式",
					prop: "mobile"
				}, {
					label: "是否关注了“学校通知”",
					prop: "isSubscribe",
					formatter: (row) => {
						return row.isSubscribe ? '已关注' : '未关注';
					}
				}, {
					label: "软删除",
					prop: "deleted",
					formatter: (row) => {
						return row.deleted == 1 ? '已删除' : '未删除';
					}
				}],

				//导入学生信息
				dialogImportVisible: false,
				importList: [],
				importLabel: [],
				wb:{},
				fileList:[],
				uploadData:{levelId:''},
				uploadHead:{schoolId:''},

				//发送通知
				dialogSendMsgVisible: false,
				msgForm: {
					type: '',
					content: '',
					sendIds: []
				},
				filterText: '',
				text:'',
				dynamicTags: [],
				msgInput:'',
				msgTreeData:[],
				msgTreeDefaultProps: {
					children: 'children',
					label: 'label'
				},
				
				//同步数据
				dialogSynchronization:false,
				synchronizationHtml:''

			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		created() {
			this.uploadHead.schoolId = localStorage.getItem("schoolId");
			this.getData();
			levelTreeApi({}).then((res) => {
				if (res.code == 200) {
					this.data = res.data;
				}
			}).catch((err) => {});
		},
		methods: {
			getData() {
				cpStudentPageApi(this.searchForm).then((res) => {
					if (res.code == 200) {
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search() {
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm() {
				this.searchForm = {
					levelIds: [],
					nick: null,
					studentNo: null,
					isSearchCount: true,
					limit: 10,
					page: 1
				}
				this.uploadData.levelId = '';
				this.getData();
			},
			//导入学生信息
			importInfo() {
				if(this.uploadData.levelId == ''){
					this.$message.warning("请先选择班级");
					return;
				}
				this.dialogImportVisible = true;
			},
			importExcel(file,fileList){
				let _this = this;
				_this.file2Xce(file).then(item => {
					if(item && item.length>0){
						if(item[0] && item[0].sheet && item[0].sheet.length){
							_this.importLabel = [{
								label: "学生姓名",
								prop: "学生姓名"
							}, {
								label: "学号",
								prop: "学号"
							}, {
								label: "身份证",
								prop: "身份证"
							}];
							_this.importList = item[0].sheet;
						}
					}
				}).catch(error => {
					loading.close();
				})
				if (fileList.length > 0) {
					_this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
				}
			},
			file2Xce(file){
				return new Promise(function(resolve,reject){
					const reader = new FileReader();
					reader.onload = function(e){
						const data = e.target.result;
						this.wb = XLSX.read(data,{
							type:"binary"
						})
						const result = [];
						this.wb.SheetNames.forEach(sheetName => {
							result.push({
								sheetName:sheetName,
								sheet:XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName])
							})
						})
						resolve((result))
					}
					reader.readAsBinaryString((file.raw))
				})
			},
			importConfirm(){
				this.$nextTick(() => {
					this.$refs.upload.submit()
				})
			},
			importSuccess(res){
				this.dialogImportVisible = false;
				this.$message.success("导入成功");
				this.getData();
			},
			//同步数据
			synchronous() {
				this.loading = true;
				cpStudentSyncApi({}).then((res) => {
					if (res.code == 200) {
						this.$message.success("同步成功");
						this.loading = false;
						this.getData();
						if(res.data.length > 0){
							this.synchronizationHtml = '';
							this.dialogSynchronization = true;
							for(var i=0;i<res.data.length;i++){
								var length = res.data.length;
								var comma = i==length-1 ? '' : ',';
								this.synchronizationHtml += res.data[i]+comma;
							}
						}
					}
				}).catch((err) => {});
			},
			//编辑
			edit(row) {
				this.form = {
					studentName: row.studentName,
					studentNo: row.studentNo,
					idCard: row.idCard,
					type: row.type+'',
					id: row.id
				};
				this.dialogFormVisible = true;
			},
			formSubmit() {
				updateStudentInfoApi(this.form).then((res) => {
					if (res.code == 200) {
						this.$message.success("编辑成功");
						this.dialogFormVisible = false;
						this.getData();
					}
				}).catch((err) => {});
			},
			//家长列表
			parentsList(row) {
				this.parentList = [];
				parentListApi({
					studentId: row.id
				}).then((res) => {
					if (res.code == 200) {
						this.parentList = res.data;
					}
				}).catch((err) => {});
				this.dialogParentListVisible = true;
			},
			//同步
			singleSynchronous(row) {
				syncOneApi({
					id: row.id
				}).then((res) => {
					if (res.code == 200) {
						this.$message.success("同步成功");
						this.getData();
					}
				}).catch((err) => {});
			},
			//发送通知
			sendMsg(row) {
				if(row){
					this.msgForm.type = '学生';
					this.text = '学生';
					row.label = row.studentName + '(' + row.levelName + ')';
					this.dynamicTags = [];
					this.dynamicTags.push(row);
				}else{
					this.msgForm.type = '班级';
					this.text = '班级';
					this.dynamicTags = [];
				}
				this.msgForm.content = '';
				this.msgTreeData = [];
				this.dialogSendMsgVisible = true;
			},
			radioChange(val){
				this.text = val;
			},
			send() {
				if(this.msgForm.content == ''){
					this.$message.warning("请先输入通知内容");
					return;
				}
				var sendIds = [];
				if(this.msgForm.type == '学生'){
					for(var i=0;i<this.dynamicTags.length;i++){
						sendIds.push(this.dynamicTags[i].id)
					}
				}else{
					sendIds = this.noRepeat(this.msgForm.sendIds);
				}
				var form = {
					content:this.msgForm.content,
					type:this.msgForm.type == '学生' ? '1' : '2',
					sendIds: sendIds
				}
				sendParentMessageApi(form).then((res) => {
					if (res.code == 200) {
						this.$message.success("发送成功");
						this.dialogSendMsgVisible = false;
					}
				}).catch((err) => {});
			},
			//树
			handleNodeClick(data, node) {
				node.expanded = true;
				if(data.childrenIds == null){
					this.searchForm.levelIds = [];
				}else{
					this.searchForm.levelIds = data.childrenIds.join(',');
				}
				this.searchForm.page = 1;
				this.getData();
				if(data.children == null){
					this.uploadData.levelId = data.childrenIds[0];
				}
			},
			dialogHandleNodeClick(data, node) {
				node.expanded = true
			},
			handleCheckChange(data, checked, indeterminate) {
				if(data.childrenIds != null && data.childrenIds.length == 1){
					if(checked){
						this.msgForm.sendIds.push(data.childrenIds);
					}else{
						var index = this.msgForm.sendIds.indexOf(data.childrenIds);
						if (index > -1) {
							this.msgForm.sendIds.splice(index, 1);
						}
					}
				}
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			msghHandleCheckChange(data, checked, indeterminate){
				if(this.dynamicTags.length == 0){
					this.dynamicTags.push(data);
					this.msgTreeData = [];
					this.msgInput = '';
				}else{
					var flag=false;
					for(var i = 0;i<this.dynamicTags.length;i++){
						if(this.dynamicTags[i].id == data.id){
							flag=true;
						}
					}
					if(flag==false){
						this.dynamicTags.push(data);
						this.msgTreeData = [];
						this.msgInput = '';
					}
				}
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit = val;
				this.searchForm.page = 1;
				this.getData();
			},
			handleCurrentChange(val) {
				this.searchForm.page = val;
				this.getData();
			},
			//数组去重
			noRepeat(arr){
				var newArr=[]; 
				for(var i=0;i<arr.length;i++) {
					if(newArr.indexOf(arr[i][0]) === -1) {
						newArr.push(arr[i][0]);
					}
				}
				return newArr
			},
			//标签X
			handleClose(tag,i) {
				this.dynamicTags.splice(i, 1);
			},
			//输入学生姓名进行搜索
			handlerChange(e){
				if(e.length >= 2){
					cpLikeNameApi({name:e}).then((res) => {
						if (res.code == 200) {
							for(var i =0;i<res.data.length;i++){
								res.data[i].label = res.data[i].studentName + '(' + res.data[i].levelName + ')'
							}
							this.msgTreeData = res.data;
						}
					}).catch((err) => {});
				}else{
					this.msgTreeData = [];
				}
			},
			//复制
			copy() {
				const text = document.createElement('textarea'); // 创建节点
				text.setAttribute('readonly', 'readonly');
				text.value = this.synchronizationHtml; // 赋值
				document.body.appendChild(text); // 插入节点
				text.setSelectionRange(0, text.value.length);
				text.select(); // 选中节点
				document.execCommand('copy'); // 执行浏览器复制方法
				if (document.body.removeChild(text)) {
					this.$message({ type: 'success', message: '复制成功' })
				} else {
					this.$message({ type: 'error', message: '复制失败' })
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.tree-box .is-horizontal{
		display: none;
	}
	/deep/.tree-box .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	/deep/.tree-box .el-tree{
		border: 1px solid #EBEEF5;
		padding: 15px 0;
	}
	/deep/.el-table__empty-block {
		width: 100% !important;
	}
	.classAndGrade .el-input{
		width: 100% !important;
		margin-bottom: 10px;
	}
	/deep/.msgDialog .el-dialog{
		width: 70%;
	}
	/deep/.el-dialog .el-form--inline .el-form-item{
		width: 50%;
    	text-align: left;
		margin-right:0;
	}
	/deep/.el-dialog .el-form--inline .el-form-item__content{
		width: 84%;
	}
	/deep/.el-dialog .el-textarea{
		width:100% !important;
	}
	/deep/.el-dialog .el-textarea .el-textarea__inner{
		min-height: 180px !important;
	}
</style>
